/* eslint-disable no-console */
import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import { AxiosError, AxiosResponse } from 'axios'
import ajustarEstabelecimento from 'Hooks/estabelecimento/ajustarEstabelecimento'
import estabelecimentoApiService, { EstabelecimentoApi } from 'Services/api/estabelecimento'

import { Estabelecimento } from './types'

interface UseEstabelecimentosResult {
  estabelecimentosRequest: {
    data: Estabelecimento[]
    hasError: boolean
    isLoading: boolean
  }
}

const useEstabelecimentos = (): UseEstabelecimentosResult => {
  const [data, setData] = useState<Estabelecimento[]>([])
  const [hasError, setHasError] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    estabelecimentoApiService
      .listEstabelecimentos()
      .then((response: AxiosResponse<EstabelecimentoApi[]>) => response.data)
      .then((estabelecimentos: EstabelecimentoApi[]) => estabelecimentos.map(ajustarEstabelecimento))
      .then(setData)
      .catch((error: AxiosError | Error | any) => {
        Sentry.captureException(error)
        console.log(error)
        setHasError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return {
    estabelecimentosRequest: { data, hasError, isLoading }
  }
}

export default useEstabelecimentos
